import React from "react";
import styles from "./NegotiationBot.module.css";
import {
  getDecisionClassKey,
  getDecisionText,
  normalizeMoneyText,
} from "./negotiationUtils";

const NegotiationAnalysis = ({
  history,
  selectedVendorTokens,
  onToggleVendor,
  onToggleAll,
  onSendRequest,
  loading,
}) => {
  const quotations = Array.isArray(history?.current_quotations)
    ? history.current_quotations
    : [];
  const selectedCount = selectedVendorTokens.length;
  const bestQuote = quotations[0] || {};

  return (
    <section className={styles.panel}>
      <div className={styles.compactHeader}>
        <div>
          <span className={styles.eyebrow}>Buyer intelligence</span>
          <h4>{history?.item?.item_name || "Negotiation item"}</h4>
          <p>
            {history?.rfq?.rfq_code || "-"} | {history?.item?.quantity || "-"}{" "}
            {history?.item?.unit || ""}
          </p>
        </div>
        <span className={styles.statusPill}>
          {selectedCount} of {quotations.length} selected
        </span>
      </div>

      <div className={styles.metricGrid}>
        <div className={styles.metric}>
          <span>Previous purchase</span>
          <strong>
            {normalizeMoneyText(
              history?.previous_purchase?.unit_price,
              history?.previous_purchase?.currency,
            )}
          </strong>
        </div>
        <div className={styles.metric}>
          <span>Current quote</span>
          <strong>
            {normalizeMoneyText(bestQuote?.unit_price, bestQuote?.currency)}
          </strong>
        </div>
        <div className={styles.metric}>
          <span>Target</span>
          <strong>
            {normalizeMoneyText(
              history?.target?.target_price,
              history?.target?.currency || "INR",
            )}
          </strong>
        </div>
        <div className={styles.metric}>
          <span>Benchmark</span>
          <strong>
            {normalizeMoneyText(
              history?.benchmark?.vendor_average,
              history?.benchmark?.currency,
            )}
          </strong>
        </div>
        <div className={styles.metric}>
          <span>Strategy</span>
          <strong>{bestQuote?.strategy || "-"}</strong>
        </div>
        <div className={styles.metric}>
          <span>Decision</span>
          <strong>{getDecisionText(bestQuote?.decision)}</strong>
        </div>
      </div>

      <div className={styles.conversationNote}>
        <div className={styles.chatBubbleBuyer}>
          Price is higher than previous purchase. Please revise your quotation
          and share your best possible offer.
        </div>
      </div>

      <div className={styles.vendorTableHeader}>
        <label className={styles.checkLabel}>
          <input
            type="checkbox"
            checked={quotations.length > 0 && selectedCount === quotations.length}
            onChange={onToggleAll}
          />
          Select all quoted vendors
        </label>
      </div>

      <div className={styles.vendorQuoteList}>
        {quotations.map((quote) => {
          const token = quote.vendor_bid_item_token || "";
          const checked = selectedVendorTokens.includes(token);
          const decisionClass = styles[getDecisionClassKey(quote.decision)];

          return (
            <label className={styles.vendorQuoteCard} key={token || quote.vendor_token}>
              <input
                type="checkbox"
                checked={checked}
                disabled={!token}
                onChange={() => onToggleVendor(token)}
              />
              <div>
                <strong title={quote.vendor_name}>{quote.vendor_name || "-"}</strong>
                <span>
                  {normalizeMoneyText(quote.unit_price, quote.currency)} |{" "}
                  {quote.strategy || "-"}
                </span>
              </div>
              <small className={`${styles.decisionPill} ${decisionClass}`}>
                {getDecisionText(quote.decision)}
              </small>
            </label>
          );
        })}
      </div>

      <div className={styles.bottomActionArea}>
        <button
          type="button"
          className={styles.primaryBtn}
          disabled={loading || selectedCount === 0}
          onClick={onSendRequest}
        >
          {loading ? "Sending..." : "Send Revision Request"}
        </button>
      </div>
    </section>
  );
};

export default NegotiationAnalysis;
